import React, { Component, Fragment } from "react";

import "./AutoCompleteExtension.css";

export const CHAT_AUTOCOMPLETE_EXT_ID = "CHAT_AUTOCOMPLETE";

export default class AutoCompleteExtension extends Component {
  constructor(props) {
    super();

    this.state = {
      searchTerm: "",
      bottomMargin: 0,
      filteredSuggestions: [],
      maximised: false,
    };

    this.onSuggestionClicked.bind(this);

    // Finds the input box and listens to it
    // Hacky, but WebChat doesn't expose an API for listening to input
    this.findInputTimerId = setInterval(() => {
      let chatbox = document.getElementById("chat_box");
      if (!chatbox) {
        return;
      }
      let inputs = chatbox.querySelectorAll("input");
      let inputRegion = chatbox.querySelectorAll("[role='form']");

      if (inputs.length < 1 || inputRegion.length < 1) {
        return;
      }

      this.setState({
        bottomMargin: inputRegion[0].clientHeight,
      });
      this.updateSuggestions();
      clearInterval(this.findInputTimerId);
    }, 50);
  }

  componentDidUpdate(oldProps) {
    if (!this.props.suggestions) {
      return;
    }

    if (oldProps.suggestions !== this.props.suggestions) {
      this.updateSuggestions();
    }
  }

  updateSuggestions() {
    this.setState({
      maximised: this.props.suggestions.length > 0 ? true : false,
      filteredSuggestions: this.props.suggestions,
    });
  }

  onSuggestionClicked(suggestion) {
    this.props.api.sendActivity({
      type: "WEB_CHAT/SEND_MESSAGE",
      payload: { text: suggestion },
    });
    this.props.api.sendActivity({
      type: "WEB_CHAT/SET_SEND_BOX",
      payload: { text: "" },
    });
    this.setState({ maximised: !this.state.maximised });
  }

  componentDidMount() {
    const self = this;
    var ignoreClickOnMeElement = document.getElementById("chat_box");
    if (
      ignoreClickOnMeElement !== null &&
      ignoreClickOnMeElement !== undefined
    ) {
      document.addEventListener("click", function (event) {
        if (self.state.maximised === true) {
          var isClickInsideElement = ignoreClickOnMeElement.contains(
            event.target
          );
          if (isClickInsideElement) {
            self.setState({ maximised: false });
          }
        }
      });
    }
  }

  render() {
    const color = this.props.styling;
    return (
      <Fragment>
        {this.state.maximised && this.state.filteredSuggestions.length > 0 ? (
          <Fragment>
            <div
              className="chat_auto_suggestion_container"
              style={{
                height: "calc(79% - 38px)",
              }}
            >
              <div className="chat_auto_suggestion_results">
                <div className="chat_auto_suggestion_header">
                  <div>
                    {" "}
                    <img src="https://bmbuiassetsprod.blob.core.windows.net/images/minimizeresults.png" />{" "}
                  </div>
                  <span> Suggestions </span>
                </div>
                {this.state.filteredSuggestions.map((suggestion) => (
                  <div
                    className="chat_auto_suggestion_item"
                    key={suggestion.response}
                    onClick={() => {
                      this.onSuggestionClicked(suggestion.response);
                    }}
                  >
                    <div className="chat_auto_suggestion_item_inner">
                      <div
                        className="chat_auto_suggestion_item_select_box"
                        style={{
                          backgroundColor: color.colours.header,
                          border: `solid 1px ${color.colours.headerText}`,
                        }}
                      >
                        {" "}
                      </div>
                      <div className="chat_auto_suggestion_item_text">
                        {" "}
                        {suggestion.response}{" "}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="chat_auto_suggestion_header_minimise"
              style={{
                borderColor: color.colours.header,
                bottom: '48px',
              }}
              onClick={() => {
                this.setState({ maximised: !this.state.maximised });
              }}
            >
              {this.state.maximised ? "Hide" : ""}
            </div>
          </Fragment>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}
